import * as React from "react";
import { styled } from "@mui/material";
import { BottomNavigationButton } from "../common/rosebudButtomNavigationButton";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { NavigationLink } from "../util/rosebudRoutesSettings";
import { useRouteHelper, useWizardSteps } from "../useRouteHelper";
import { SantanaStepper } from "../common/santanaStepper";
import { AgentRoute } from "../util/agentRoutes";

export const RosebudDesktopBottomNavigationHeight = 77;

//region [[ Styles ]]

const RousebudDesktopBottomNavigationView = styled("div")(
  ({ inwizard }: { inwizard: "true" | "false" }) => ({
    display: "flex",
    width: "100%",
    flexFlow: "row-reverse",
    justifyContent: inwizard === "true" ? "center" : "space-between",
    background: "white",
    height: `${RosebudDesktopBottomNavigationHeight}px`,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  }),
);

const ButtonSection = styled("div")((props: { wizard?: string }) => ({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: props.wizard === "true" ? "center" : "flex-end",
  width: "22%",
  height: "100%",
}));

const BottomNavigationButtonStyled = styled(BottomNavigationButton)({
  borderRadius: "40px",
  height: "36px",
  marginRight: "15px",
  fontSize: "16px",
  width: "110px",
  marginLeft: "15px",
  boxShadow: "unset",
  color: "white",
  backgroundColor: "#4247C9",

  "&:focus, &:hover, &:active": {
    color: "white",
    boxShadow: "unset",
    backgroundColor: "#4247C9",
  },
});

const StepperSection = styled("div")({
  width: "100%",
  maxWidth: "400px",
  marginTop: "15px",
  marginRight: "-40px",
  marginLeft: "-40px",

  "& .MuiStepLabel-label": {
    whiteSpace: "nowrap",
    width: "110px",
    marginTop: "5px !important",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RousebudDesktopBottomNavigationProps {
  className?: string;
  next: NavigationLink;
  // Allow overriding the default behaviour
  onNextClicked?: () => void;
  back?: NavigationLink;
  onBackClicked?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DesktopBottomNavigation = ({
  ...props
}: RousebudDesktopBottomNavigationProps) => {
  const { inWizard, nextRouteNavigationDisabled } = useDiagnosticNavigation();
  const { wizardSteps } = useWizardSteps();
  const { currentWizardIndex, getCurrentRouteSettings } = useRouteHelper();

  const nextText =
    props.next.displayText === "Done"
      ? inWizard
        ? "Done"
        : "Update"
      : props.next.displayText;

  const isTerms = getCurrentRouteSettings().route === AgentRoute.TermsOfService;

  return (
    <RousebudDesktopBottomNavigationView
      className={`rousebud-desktop-bottom-navigation-view ${props.className ||
        ""}`}
      inwizard={inWizard && !isTerms ? "true" : "false"}
    >
      <ButtonSection wizard={inWizard ? "true" : "false"}>
        <BottomNavigationButtonStyled
          main={"true"}
          wizard={inWizard ? "true" : "false"}
          onClick={props.onNextClicked}
          disabled={nextRouteNavigationDisabled}
        >
          {nextText}
        </BottomNavigationButtonStyled>
      </ButtonSection>
      {inWizard && !isTerms && (
        <StepperSection>
          <SantanaStepper steps={wizardSteps} current={currentWizardIndex} />
        </StepperSection>
      )}
      <ButtonSection wizard={inWizard ? "true" : "false"}>
        {props.back && (
          <BottomNavigationButtonStyled onClick={props.onBackClicked}>
            {inWizard ? "Back" : props.back.displayText}
          </BottomNavigationButtonStyled>
        )}
      </ButtonSection>
    </RousebudDesktopBottomNavigationView>
  );
};
